import { isBrowser } from "../../../utils/ssr";

export function navigateToMyAccount(locale: string | undefined) {
  if (!isBrowser()) {
    return;
  }
  const baseUrl = process.env.GATSBY_WEBSITE_URL || window.location.origin;
  switch (locale) {
    case "sv":
      window.location.href = baseUrl + `/se/my-account`;
      break;
    case "es":
      window.location.href = baseUrl + `/es/mi-cuenta`;
      break;
    default:
      window.location.href = baseUrl + `/my-account`;
      break;
  }
}
